/*
 * @Description: 价目管理 新增、编辑弹出层
 * @Author: ma.cq
 * @Date: 2018-10-18 09:33:29
 * @LastEditors: ma.cq
 * @LastEditTime: 2018-11-01 14:16:44
 */
<template>
  <el-dialog title="新增客户退款申请" :visible.sync="visible" @close="handleClose" width="600px">
    <el-form class="form" :model="form" inline :rules="rules" ref="form" v-if="visible">
      <el-form-item label="调账类型" prop="ces1" label-width="125px">
        <el-select v-model="form.ces1" placeholder="请选择">
          <el-option
            v-for="item in orderType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经营组织" prop="org" label-width="125px">
        <ajax-select
        v-model="form.org"
        type="allArg"
        no-all
        clearable
        placeholder="请选择经营组织"
        valueField="obj"
        @change="handleOrgChange"></ajax-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="org" label-width="125px">
      <!-- 政策部门选择客户 -->
      <tag-search-select
        v-if="form.hasPolicyPermission && form.type === 1 && form.agreementType === 0"
        v-model="form.customList"
        type="customPolicy"
        placeholder="请输入客户名称"
        :extra-params="{ deptID: form.org.id }"
        :disabled="!form.org"
        :limit="1"
        @change="handleCusChange">
      </tag-search-select>
      <!-- 非政策部门选择客户 -->
      <tag-search-select
        v-else
        v-model="form.customList"
        type="customer"
        placeholder="请输入客户名称"
        :extra-params="{ deptID: form.org.id }"
        :disabled="!form.org"
        :limit="1"
        @change="handleCusChange">
      </tag-search-select>
      </el-form-item>
      <el-form-item label="协议编号" label-width="125px">
        <el-input placeholder="请输入协议编号" v-model="form.protocol"></el-input>
        <!-- <ajax-select
        v-model="form.protocol"
        type="protocol"
        no-all
        clearable
        :disabled="!memberId"
        :extra-params="{ memberId: memberId }"
        placeholder="请选协议编号"
        valueField="obj"
        @change="onProtocolChange"></ajax-select> -->
      </el-form-item>
      <el-form-item label="币种" prop="ces4" label-width="125px">
        <el-select v-if="currency" v-model="form.ces4" placeholder="请选择">
          <el-option
            v-for="item in moneyTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else v-model="form.ces4" placeholder="请选择">
          <el-option
            v-for="item in moneyType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="金额" prop="ces5" label-width="125px">
        <el-input-number
          controls-position="right"
          v-model="form.ces5"
          :max="9999999999"
          :min="0"
          :precision="2"></el-input-number>
          <!-- <span style="margin-left: 10px;color: red;">当前额度{{ money }}</span> -->
      </el-form-item>
      <el-form-item label="增款客户" prop="ces10" label-width="125px" v-if="form.ces1=='4'">
        <tag-search-select
        v-if="form.hasPolicyPermission && form.type === 1 && form.agreementType === 0"
        v-model="form.ces10"
        type="customPolicy"
        placeholder="请输入客户名称"
        :extra-params="{ deptID: form.org.id }"
        :disabled="!form.org"
        :limit="1"
        @change="handleCusChanges">
      </tag-search-select>
      <!-- 非政策部门选择客户 -->
      <tag-search-select
        v-else
        v-model="form.ces10"
        type="customer"
        placeholder="请输入客户名称"
        :extra-params="{ deptID: form.org.id }"
        :disabled="!form.org"
        :limit="1"
        @change="handleCusChanges">
      </tag-search-select>
        <!-- <el-input
          controls-position="right"
          v-model="form.ces10"></el-input> -->
      </el-form-item>
      <el-form-item label="增款协议编号" label-width="125px" v-if="form.ces1=='4'">
        <ajax-select
        v-model="form.ces11"
        type="protocol"
        no-all
        clearable
        :disabled="!memberIds"
        :extraParams="{ memberId: memberIds }"
        placeholder="请选协议编号"
        valueField="obj"
        @change="onProtocolChanges"></ajax-select>
        <!-- <el-input
          controls-position="right"
          v-model="form.ces11"></el-input> -->
      </el-form-item>
      <el-form-item label="发起人一卡通号" prop="ces7" label-width="125px">
        <search-select
            clearable
            type="card"
            placeholder="请输入一卡通号"
            v-model="form.ces7"
            ref="cardSelect"
            @changeValue="handleChangeCard"></search-select>
        <!-- <el-input placeholder="请输入发起人一卡通号" v-model="form.ces7"></el-input> -->
      </el-form-item>
      <el-form-item label="备注" label-width="125px">
        <el-input placeholder="备注" v-model="form.remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import SearchSelect from '../../../components/searchSelect'
import AjaxSelect from '../../../components/ajaxSelect/index'
import TagSearchSelect from '../../../components/tagSearchSelect/index'
export default {
  name: 'addOrEditDialog',
  components: { TagSearchSelect, AjaxSelect, SearchSelect },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      money: 0,
      form: {
        org: '',
        pickArea: '',
        pickAreaName: '',
        deliveryArea: '',
        ces4: 1,
        ces5: 0,
        ces7: window.storage.getItem(window.storage.keys.USER_INFO).cardSolution,
        customList: []
      },
      forms: {
        org: '',
        pickArea: '',
        pickAreaName: '',
        deliveryArea: '',
        ces7: window.storage.getItem(window.storage.keys.USER_INFO).cardSolution,
        customList: []
      },
      currency: false,
      memberId: '',
      memberIds: '',
      org: '',
      rules: {
        ces1: [{ required: true, message: '请选择调账类型' }],
        org: [{ required: true, message: '请选择经营组织' }],
        customList: [{ required: true, message: '请选择客户名称' }],
        ces4: [{ required: true, message: '请选择币种' }],
        ces5: [{ required: true, message: '请填写金额' }],
        ces10: [{ required: true, message: '请填写赠款客户' }],
        ces11: [{ required: true, message: '请填写赠款协议编号' }],
        protocol: [{ required: true, message: '请填写协议编号' }],
        ces7: [{ required: true, message: '请填写发起人一卡通号' }],
        remark: [{ required: true, message: '请填写备注' }]
      },
      orderType: [
        { value: 3, label: '客户退款' }
      ],
      moneyType: [
        { value: 1, label: 'CNY' }
      ],
      moneyTypes: [],
      saleType: [
        { value: 1, label: '全部' },
        { value: 2, label: '经营组织1' },
        { value: 3, label: '经营组织2' }
      ]
    }
  },
  methods: {
    ...mapActions([
      'getAccountAdd',
      'getPush',
      'getUe',
      'getUes',
      'getAccountList'
    ]),
    handleSubmit () {
      console.log(this.form)
      if (this.form.customList.length <= 0) {
        this.$message.error('请确认选择的客户')
        return
      }
      // if (this.form.ces5 > this.money) {
      //   this.$message.error('金额不得大于可调账金额或为0')
      //   return
      // }
      // if (this.money === 0) {
      //   this.$message.error('金额不得大于可调账金额或为0')
      //   return
      // }
      this.$emit('onform', this.form)
      this.$emit('update:show', false)
      this.form = this.forms
    },
    handleChangeCard (e) {
      console.log(e)
    },
    handleOrgChange (e) {
      console.log(e)
      if (e) {
        this.org = e.id
      } else {
        this.money = 0
      }
    },
    onProtocolChange (e) {
      console.log(e)
    },
    onProtocolChanges (e) {
      console.log(e)
    },
    handleCusChange (e) {
      console.log(e)
      if (e[0]) {
        this.memberId = e[0].id
      } else {
        this.money = 0
      }
      // this.$emit('ue', this.form)
      this.getUe({
        memberId: this.memberId,
        orgId: this.org
      }).then(res => {
        console.log(res, '8888')
        if (res.length > 0) {
          this.moneyTypes = []
          res.forEach(r => {
            if (r.currency === 'RMB') {
              this.moneyTypes.push({ value: 1, label: 'CNY' })
            }
            if (r.currency === 'USD') {
              this.moneyTypes.push({ value: 2, label: 'USD' })
            }
            if (r.currency === 'EUR') {
              this.moneyTypes.push({ value: 3, label: 'EUR' })
            }
          })
          this.currency = true
          this.form.ces4 = this.moneyTypes[0].value
          this.moneys()
        }
      })
    },
    moneys (e) {
      this.getUes({
        currencyType: this.form.ces4,
        memberId: this.memberId,
        orgId: this.org
      }).then(res => {
        console.log(res, '877788')
        if (res.totalAssets) {
          this.money = res.totalAssets
        } else {
          // this.$message.error('无可用金额')
          this.money = 0
        }
      })
    },
    handleCusChanges (e) {
      console.log(e)
      this.memberIds = e[0].id
    },
    handleClose () {
      this.form = { org: '',
        pickArea: '',
        pickAreaName: '',
        deliveryArea: '',
        ces4: 1,
        ces5: 0,
        ces7: window.storage.getItem(window.storage.keys.USER_INFO).cardSolution,
        customList: []
      }
      console.log(this.form)
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
    },
    'form.ces1' (e) {
      console.log(e)
    },
    'form.ces4' (e) {
      console.log(e)
      if (this.currency) {
        console.log(888)
        this.moneys()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form{
  margin: 0 auto;
  max-width: 500px;
}
.item-inline{
  display: inline-block;
}
.marLef10{
  margin-left: 10px;
}
.tip{
  color: #ccc;
  font-size: 12px;
}
.tag{
  margin: 10px 10px 0 0;
}
.timepicker{
  margin-right: 10px;
  width: 120px;
}
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
</style>
